import { RemoteGetKeyPreview } from 'data/usecases/partners';
import { makeApiUrlPartnerRequestKeyPreview } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetKeyPreview = (): RemoteGetKeyPreview => {
  return new RemoteGetKeyPreview(
    makeApiUrlPartnerRequestKeyPreview(),
    makeAxiosHttpClient(),
  );
};
